import { render, staticRenderFns } from "./CountUp.vue?vue&type=template&id=4ccdf592&scoped=true&"
import script from "./CountUp.vue?vue&type=script&lang=js&"
export * from "./CountUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccdf592",
  null
  
)

export default component.exports